import { render, staticRenderFns } from "./work_items_new_saved_view_modal.vue?vue&type=template&id=2c6a6097"
import script from "./work_items_new_saved_view_modal.vue?vue&type=script&lang=js"
export * from "./work_items_new_saved_view_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports